import { defineMessages } from 'react-intl'

export default defineMessages({
  title: { id: 'signup.title', defaultMessage: 'Create your LogikSpark workspace' },
  subtitle: {
    id: 'signup.subtitle',
    defaultMessage: 'Pick a workspace address and we’ll email you a link to finish setting up.',
  },
  subdomainLabel: { id: 'signup.subdomain.label', defaultMessage: 'Workspace subdomain' },
  subdomainHelp: { id: 'signup.subdomain.help', defaultMessage: 'Lowercase letters, numbers and hyphens, 3–32 characters.' },
  emailLabel: { id: 'signup.email.label', defaultMessage: 'Work email' },
  orgNameLabel: { id: 'signup.orgName.label', defaultMessage: 'Organisation name' },
  currencyLabel: { id: 'signup.currency.label', defaultMessage: 'Default currency' },
  acceptTerms: { id: 'signup.acceptTerms', defaultMessage: 'I accept the terms of service' },
  submit: { id: 'signup.submit', defaultMessage: 'Create workspace' },

  // Subdomain-availability pill.
  checking: { id: 'signup.pill.checking', defaultMessage: 'Checking…' },
  available: { id: 'signup.pill.available', defaultMessage: 'available' },
  taken: { id: 'signup.pill.taken', defaultMessage: 'already taken' },
  reserved: { id: 'signup.pill.reserved', defaultMessage: 'reserved' },
  invalidFormat: { id: 'signup.pill.invalidFormat', defaultMessage: 'invalid format' },
  pillError: { id: 'signup.pill.error', defaultMessage: 'could not check' },

  // Check-email screen.
  checkEmailTitle: { id: 'signup.checkEmail.title', defaultMessage: 'Check your email' },
  checkEmailBody: {
    id: 'signup.checkEmail.body',
    defaultMessage: 'We sent a verification link to {email}. Click it to finish creating your workspace.',
  },

  // Expired / invalid-link screens.
  expiredTitle: { id: 'signup.expired.title', defaultMessage: 'This link has expired' },
  expiredBody: {
    id: 'signup.expired.body',
    defaultMessage: 'Verification links are valid for 24 hours. Start again to get a fresh link.',
  },
  invalidTitle: { id: 'signup.invalid.title', defaultMessage: 'This link is no longer valid' },
  invalidBody: {
    id: 'signup.invalid.body',
    defaultMessage: 'It may already have been used. Start again to get a new link.',
  },
  startAgain: { id: 'signup.startAgain', defaultMessage: 'Back to sign up' },
})
